import { z } from 'zod';
import { jsonObjectSchema } from './json.ts';

export const protocolSchemaDescriptorSchema = z.object({
  key: z.string().regex(
    /^[a-z0-9][a-z0-9-]*(?:\.[a-z0-9][a-z0-9-]*)+@\d+$/,
    '协议键必须使用 namespace.name@version 格式',
  ),
  title: z.string().min(1).max(500),
  description: z.string().max(5000).default(''),
  schemaVersion: z.string().min(1).max(100),
  jsonSchema: jsonObjectSchema,
  semanticConstraints: z.array(z.string().min(1).max(2000)).max(200).default([]),
  aiGuidance: z.array(z.string().min(1).max(2000)).max(200).default([]),
}).strict();

export type ProtocolSchemaDescriptor = z.infer<
  typeof protocolSchemaDescriptorSchema
>;
